import React from "react";
import { TURNOS } from "../consts";
import styles from "./HorarioCellEditor.module.scss";

/**
 * Editor de celda-día: una opción de la lista, o sin cargar.
 *
 * Las opciones vienen por prop porque las dos solapas tienen listas distintas: Turnos usa los
 * cinco códigos (M/T/N/F/L) y TEx usa los seis de guardia, compuestos incluidos. El editor no
 * sabe de cuál se trata.
 *
 * Preserva la observación existente del día. El <select> nativo da soporte de teclado gratis
 * (type-ahead, flechas, Enter/Escape).
 */
export default function HorarioCellEditor({ opciones = TURNOS, ...params }) {
  const { id, field, value, api } = params;
  const codigo = value?.codigo ?? "";

  const cambiar = (nuevoCodigo) => {
    api.setEditCellValue({ id, field, value: { ...(value ?? {}), codigo: nuevoCodigo } });
  };

  const manejarTeclado = (e) => {
    if (e.key === "Enter") api.stopCellEditMode({ id, field });
    if (e.key === "Escape") api.stopCellEditMode({ id, field, ignoreModifications: true });
  };

  return (
    <select
      autoFocus
      className={styles.select}
      value={codigo}
      onChange={(e) => cambiar(e.target.value)}
      onKeyDown={manejarTeclado}
    >
      {/* Vacio = sin cargar, que no es lo mismo que franco: el franco es "F" y es una
          decision tomada. Esta opcion esta para poder DESHACER una carga. */}
      <option value="">— Sin cargar</option>
      {opciones.map((t) => (
        <option key={t.codigo} value={t.codigo}>
          {t.codigo} — {t.label}
        </option>
      ))}
    </select>
  );
}
